import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import './IntroCompletePage.scss'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import HeaderMenu from '../../Components/Commons/HeaderMenu'

class IntroCompletePage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            project: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadProject()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    loadProject = () => {
        axios
            .get(`${BACKEND_HOST}/projects/${this.props.cookies.get('project')}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)

                this.setState({
                    project: res.data,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        if (this.state.project) {
            //날짜 변환
            const newDate = new Date(this.state.project.endDate)
            const dueDateSec = newDate.getTime()

            const nowTime = new Date()
            nowTime.setHours(12)
            nowTime.setMinutes(0)
            nowTime.setSeconds(0)
            nowTime.setMilliseconds(0)
            const nowDateSec = nowTime.getTime()

            let dday = dueDateSec - nowDateSec
            dday = Math.floor(dday / (1000 * 60 * 60 * 24))

            if (dday < 0) {
                dday = 'D+' + Math.abs(dday)
            } else {
                dday = 'D-' + dday
            }

            return (
                <div>
                    <HeaderMenu />
                    <div className="section_wrap section_wrap_menu">
                        {this.state.project.status === 'FINISH' ? (
                            <div className="intro_complete_wrap">
                                <div className="top_bg_wrap">
                                    {this.state.project.thumbnailUrl && this.state.project.thumbnailUrl !== '' && (
                                        <img src={this.state.project.thumbnailUrl} alt="bg" />
                                    )}

                                </div>
                                <div className="box_wrap">
                                    <div className="box_inside_wrap">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="22"
                                            height="20"
                                            viewBox="0 0 22 20">
                                            <path
                                                fill="#EFF1F7"
                                                fillRule="evenodd"
                                                d="M6 10.389h3.6V19.6H0v-6.97C0 5.015 3.2.94 9.6.4v3.454C7.2 4.497 6 6.344 6 9.394v.995zm12.4 0H22V19.6h-9.6v-6.97C12.4 5.015 15.6.94 22 .4v3.454c-2.4.643-3.6 2.49-3.6 5.54v.995z"
                                            />
                                        </svg>
                                        <div className="box_text">
                                            <h1>
                                                완공된<span>{this.state.project.title}</span>
                                            </h1>
                                        </div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="22"
                                            height="20"
                                            viewBox="0 0 22 20">
                                            <path
                                                fill="#EFF1F7"
                                                fillRule="evenodd"
                                                d="M16 9.611h-3.6V.4H22v6.97c0 7.614-3.2 11.69-9.6 12.23v-3.454c2.4-.643 3.6-2.49 3.6-5.54v-.995zm-12.4 0H0V.4h9.6v6.97c0 7.614-3.2 11.69-9.6 12.23v-3.454c2.4-.643 3.6-2.49 3.6-5.54v-.995z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div
                                    className="intro_content inner_html"
                                    dangerouslySetInnerHTML={{ __html: this.state.project.complete }}></div>
                                <Link to={'/report/'}>
                                    <div className="list_btn common_wrap">
                                        진행과정 보기
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="7"
                                            height="12"
                                            viewBox="0 0 7 12">
                                            <path
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#6D7075"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.2"
                                                d="M1 1.5L6 6l-5 4.5"
                                            />
                                        </svg>
                                    </div>
                                </Link>
                            </div>
                        ) : (
                            <div className="intro_complete_wrap_null">
                                <div className="top_bg_wrap">
                                    {this.state.project.thumbnailUrl && this.state.project.thumbnailUrl !== '' && (
                                        <img src={this.state.project.thumbnailUrl} alt="bg" />
                                    )}
                                    <div className="text_wrap">
                                        <div className="dday">{dday}</div>
                                        <h1>{this.state.project.title}</h1>
                                        <h2>공사가 진행중입니다.</h2>
                                    </div>
                                </div>
                                <Link to={'/report/'}>
                                    <div className="link_btn">
                                        진행과정 보기
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="12"
                                            viewBox="0 0 16 12">
                                            <g
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#FFF"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.3">
                                                <path d="M1.5 6h13M9.5 1l5 5-5 5" />
                                            </g>
                                        </svg>
                                    </div>
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap"></div>
            </div>
        )
    }
}

export default withCookies(IntroCompletePage)



// WEBPACK FOOTER //
// ./Src/Containers/Intro/IntroCompletePage.js